<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="4">
        <v-card v-for="chart in donutCharts" :key="chart.id" class="card mb-2" color="primary">
          <v-card-subtitle class="text-center font-weight-bold secondary--text pb-0">
            {{ chart.title }}
          </v-card-subtitle>
          <v-card-text class="pa-1">
            <apexchart
              v-if="chart.data.series.length > 0"
              width="100%"
              height="200"
              type="donut"
              :options="chart.data.options"
              :series="chart.data.series"
            />
            <div v-else class="text-center text-caption secondary--text py-4">Sin datos</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="8">
        <v-card class="ui-module-card" color="primary" style="height: 100%">
          <v-card-subtitle class="text-center font-weight-bold secondary--text pb-0"> Por marca </v-card-subtitle>
          <v-card-text class="pa-1">
            <apexchart
              v-if="marcaChartData.series[0].data.length > 0"
              width="100%"
              height="420"
              type="bar"
              :options="marcaChartData.options"
              :series="marcaChartData.series"
            />
            <div v-else class="text-center text-caption secondary--text py-4">Sin datos</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
const MONOCHROME_THEME = {
  mode: 'light',
  monochrome: {
    enabled: true,
    color: '#1a05a3',
    shadeTo: 'light',
    shadeIntensity: 0.65,
  },
}

const CHART_TEXT_COLOR = '#e0e0e0'
const CHART_GRID_COLOR = 'rgba(224, 224, 224, 0.18)'

function buildDonutData(armas, keyExtractor) {
  const counts = {}
  for (const arma of armas) {
    const key = keyExtractor(arma) || 'Sin datos'
    counts[key] = (counts[key] || 0) + 1
  }
  const labels = Object.keys(counts)
  return {
    series: labels.map((k) => counts[k]),
    options: {
      chart: {
        type: 'donut',
        background: 'transparent',
        foreColor: CHART_TEXT_COLOR,
      },
      labels,
      legend: {
        position: 'bottom',
        fontSize: '10px',
        labels: { colors: CHART_TEXT_COLOR },
        itemMargin: { horizontal: 4, vertical: 0 },
      },
      dataLabels: {
        enabled: true,
        style: {
          colors: [CHART_TEXT_COLOR],
          fontSize: '11px',
          fontWeight: 600,
        },
      },
      tooltip: { theme: 'dark' },
      theme: MONOCHROME_THEME,
    },
  }
}

function buildBarData(armas, keyExtractor) {
  const counts = {}
  for (const arma of armas) {
    const key = keyExtractor(arma) || 'Sin datos'
    counts[key] = (counts[key] || 0) + 1
  }
  const sorted = Object.entries(counts).sort((a, b) => b[1] - a[1])
  const categories = sorted.map(([label]) => label)
  const data = sorted.map(([, count]) => count)
  return {
    series: [{ name: 'Armas', data }],
    options: {
      chart: {
        type: 'bar',
        background: 'transparent',
        foreColor: CHART_TEXT_COLOR,
      },
      plotOptions: {
        bar: {
          horizontal: true,
          borderRadius: 4,
          distributed: true,
        },
      },
      grid: {
        borderColor: CHART_GRID_COLOR,
      },
      xaxis: {
        categories,
        labels: {
          style: {
            colors: CHART_TEXT_COLOR,
            fontSize: '11px',
          },
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: CHART_TEXT_COLOR,
            fontSize: '10px',
          },
        },
      },
      legend: { show: false },
      dataLabels: {
        enabled: true,
        style: {
          colors: [CHART_TEXT_COLOR],
          fontSize: '11px',
          fontWeight: 700,
        },
      },
      tooltip: { theme: 'dark' },
      theme: MONOCHROME_THEME,
    },
  }
}

export default {
  name: 'EstadisticasInventarioArmas',

  props: {
    armas: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    donutCharts() {
      return [
        {
          id: 'estatus',
          title: 'Por estatus',
          data: buildDonutData(this.armas, (a) => a?.CatEstatus?.title),
        },
        {
          id: 'tipo',
          title: 'Por tipo',
          data: buildDonutData(this.armas, (a) => a?.CatClase?.CatTipo?.title),
        },
      ]
    },
    marcaChartData() {
      return buildBarData(this.armas, (a) => a?.CatModelo?.CatMarca?.title)
    },
  },
}
</script>
